import { useMemo } from "react"

import type { FlowStep } from "@/lib/flows/base/types"

export function useFlowProgress(
  currentStateValue: string,
  flowSteps: FlowStep[],
) {
  return useMemo(() => {
    let currentStepIndex = -1
    let currentSubstep = 1
    let currentStep: FlowStep | undefined

    // Find which step contains the current state
    for (let i = 0; i < flowSteps.length; i++) {
      const step = flowSteps[i]
      const stateInStep = step.states.find(
        (s) => s.stateId === currentStateValue,
      )

      if (stateInStep) {
        currentStepIndex = i
        currentSubstep = stateInStep.substep
        currentStep = step
        break
      }
    }

    // If state not found, default to first step
    if (currentStepIndex === -1) {
      currentStepIndex = 0
      currentStep = flowSteps[0]
      currentSubstep = 1
    }

    return {
      currentStepIndex,
      currentStep,
      currentSubstep,
      totalSteps: flowSteps.length,
      steps: flowSteps.map((step, index) => {
        // Determine status based on current step index; it'll be completed
        // if it's before the current step, active if it's the current step,
        // and incomplete if it's after the current step.
        let status: "active" | "completed" | "incomplete"
        if (index < currentStepIndex) {
          status = "completed"
        } else if (index === currentStepIndex) {
          status = "active"
        } else {
          status = "incomplete"
        }

        return {
          ...step,
          status,
          currentSubstep:
            index === currentStepIndex ? currentSubstep : undefined,
          totalSubsteps: step.states.length,
        }
      }),
    }
  }, [currentStateValue])
}
